<script setup lang="ts">
import {
  auctionPlatformSearchTabs,
  nonAuctionPlatformSearchTabs,
  SearchResultTypes,
} from "~/types/Search";

definePageMeta({
  ssr: true,
  key: (route) => transformRouteParams(route.params.searchTerm, "string"),
  middleware: (route) => {
    const localePath = useLocalePath();
    const tab = transformRouteParams<SearchResultTypes>(
      route.params.tab,
      "string",
    );

    const platformStore = usePlatformStore();
    const isAuctionsEnabled =
      platformStore.tryGetPlatformConfiguration?.isAuctionsEnabled;

    const allowedTabs = isAuctionsEnabled
      ? auctionPlatformSearchTabs
      : nonAuctionPlatformSearchTabs;

    if (tab && !allowedTabs.includes(tab)) {
      // Only allow certain tabs
      return navigateTo(localePath({ path: "/not-found" }));
    }
  },
});

const route = useRoute();
const tab = computed(
  () =>
    transformRouteParams<SearchResultTypes>(route.params.tab, "string") ||
    SearchResultTypes.TopResults,
);

const searchTerm = computed(() => route.params.searchTerm as string);

useSchemaOrg([
  defineWebPage({
    type: ["CollectionPage", "SearchResultsPage"],
  }),
]);
</script>

<template>
  <div class="pb-6">
    <SearchResultPageHeader
      :search-term="searchTerm"
      :tab="tab"
    >
      <SearchResultPageAll
        v-if="tab === SearchResultTypes.TopResults"
        :search-term="searchTerm"
      />
      <SearchResultPageTabs
        v-else
        :key="tab"
        :search-term="searchTerm"
        :tab="tab"
      />
    </SearchResultPageHeader>
  </div>
</template>
